import React from 'react';
import { FailedSendCreditTransactionsTable } from './FailedSendCreditTransactionsTable';

export const FailedSendCreditTransactionsList: React.FC = () => {
  return <FailedSendCreditTransactionsTable />;
};
